import { emailValid, nameValid } from "@power-rent/data-validation";

export const validateInput = (key: string, value: unknown) => {
  if (key === "email" && value && !emailValid(String(value))) {
    return "Invalid email";
  }
  if ((key === "name" || key === "text") && !String(value)) {
    return `Invalid ${key}`;
  }
  return "";
};
